import React from 'react'
import { ContainerColumn } from '../ContainerColumn'
import { FieldComponent } from 'components/Shared/FieldComponent'
import { ContainerRow } from '../ContainerRow'
import { CountrySelectField } from 'components/Shared/CountrySelectField/CountrySelectField'

export function CustomsControlForm ({ name, disabled }) {
  return (
    <>
      <ContainerColumn>
        <FieldComponent
          fieldName={`${name}.customsAgencyName`}
          label="form.order.cargo.customsControl.customsAgencyName"
          disabled={disabled}
          required/>
        <FieldComponent
          fieldName={`${name}.address.address`}
          label="form.order.cargo.customsControl.address"
          disabled={disabled}
          required/>
        <FieldComponent
          fieldName={`${name}.address.city`}
          label="form.order.cargo.customsControl.city"
          disabled={disabled}
        />
        <ContainerRow>
          <CountrySelectField
            name={`${name}.address.countryCode`}
            label="form.order.cargo.customsControl.country"
            disabled={disabled}
          />
          <FieldComponent
            fieldName={`${name}.address.zipCode`}
            label="form.order.cargo.customsControl.zipCode"
            disabled={disabled}
          />
        </ContainerRow>
      </ContainerColumn>
      <ContainerColumn>
        <FieldComponent
          fieldName={`${name}.contactPersonName`}
          label="form.order.cargo.customsControl.contactPerson"
          disabled={disabled}
        />
        <FieldComponent
          fieldName={`${name}.additionalInfo`}
          label="form.order.cargo.customsControl.additionalInfo"
          disabled={disabled}
        />
      </ContainerColumn>
    </>
  )
}
